module.exports = __webpack_public_path__ + "static/theworld-2c888880c3922075f5c04abd58fd1692.jpg";